import React, { useRef, useState } from 'react';

import { backendURL } from '../../../../App';
import useImportQuestionsExcelMutation from '../../../../hooks/useImportQuestionsExcelMutation';
import './ImportQuestionsExcel.scss';

interface Props {
  anketaID: string;
}

const ImportQuestionsExcel: React.FC<Props> = ({ anketaID }) => {
  const [file, setFile] = useState<File | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const [mutate, { status, error, data, reset }] = useImportQuestionsExcelMutation(anketaID);

  // ошибки валидации приходят из ответа 400 как список готовых строк (лист/строка/колонка/описание)
  const serverErrors: string[] = (error as any)?.response?.data?.errors || [];
  // не-валидационный провал (401/500/сеть) — бэкенд не вернул список ошибок, но статус error
  const genericError = status === 'error' && serverErrors.length === 0;

  const onImport = () => {
    if (!file) return;
    mutate(file, {
      onSuccess: () => {
        // сбрасываем выбранный файл, чтобы повторный клик не отправлял тот же файл
        setFile(null);
        if (inputRef.current) inputRef.current.value = '';
      },
    });
  };

  return (
    <div className='importExcel'>
      <h3 className='importExcel__title'>Импорт из Excel</h3>
      <div className='importExcel__controls'>
        <input
          ref={inputRef}
          data-testid='excel-file-input'
          type='file'
          accept='.xlsx'
          onChange={e => {
            // сбрасываем прошлые ошибки/успех при выборе нового файла
            reset();
            setFile(e.target.files ? e.target.files[0] : null);
          }}
        />
        <button type='button' onClick={onImport} disabled={!file || status === 'loading'}>
          {status === 'loading' ? 'Импортирую…' : 'Импортировать'}
        </button>
        <a href={`${backendURL}questions/import/template/`} download>
          Скачать шаблон Excel
        </a>
      </div>
      {status === 'success' && (data as any)?.message && <p className='importExcel__success'>{(data as any).message}</p>}
      {serverErrors.length > 0 && (
        <ul className='importExcel__errors'>
          {serverErrors.map((msg, i) => (
            <li key={i}>{msg}</li>
          ))}
        </ul>
      )}
      {genericError && <p className='importExcel__genericError'>Не удалось выполнить импорт. Повторите попытку или обратитесь к администратору.</p>}
    </div>
  );
};

export default ImportQuestionsExcel;
